import { Stack, styled } from '@mui/material';

export const CustomerTypeSelectContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primaries[200],
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  borderRadius: theme.spacing(2),
}));
